(() => {
  function init(root) {
    if (root.dataset.collectionsReady) return;
    const list = root.querySelector('[data-collection-tabs]');
    if (!list) return;
    const tabs = [...list.querySelectorAll('[data-collection-tab]')];
    const panels = [...root.querySelectorAll('[data-collection-panel]')];
    if (!tabs.length) return;
    root.dataset.collectionsReady = 'true';
    const mobile = window.matchMedia('(max-width: 749px)');
    list.setAttribute('role', 'tablist');

    function centerTab(tab) {
      if (!mobile.matches) return;
      const container = list.getBoundingClientRect();
      const target = tab.getBoundingClientRect();
      list.scrollTo({
        left: list.scrollLeft + target.left - container.left - (container.width - target.width) / 2,
        behavior: 'smooth'
      });
    }

    function select(tab, focus = false, center = false) {
      tabs.forEach(item => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
        item.classList.toggle('is-current', active);
      });
      panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
      if (focus) tab.focus();
      if (center) centerTab(tab);
    }

    tabs.forEach((tab, index) => {
      tab.setAttribute('role', 'tab');
      const panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.tabIndex = 0;
      }
      tab.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        select(tab, false, true);
      });
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next == null) return;
        event.preventDefault();
        select(tabs[next], true, true);
      });
    });

    select(tabs[0]);
    document.querySelectorAll('[data-show-all-drop]').forEach(link => {
      if (link.dataset.dropReady) return;
      link.dataset.dropReady = 'true';
      link.addEventListener('click', () => select(tabs[0], false, true));
    });
    window.addEventListener('hashchange', () => { if (location.hash === '#drop') select(tabs[0], false, true); });
    root.addEventListener('shopify:block:select', event => {
      const tab = tabs.find(item => item.dataset.blockId === event.detail.blockId);
      if (tab) select(tab, false, true);
    });
  }

  function load(scope) {
    if (scope.matches?.('[data-collection-board]')) init(scope);
    scope.querySelectorAll?.('[data-collection-board]').forEach(init);
  }
  load(document);
  document.addEventListener('shopify:section:load', event => load(event.target));
})();
